import type { FaireProductEntity } from "../../entity_types/product";

export const p_822hrhadz5: FaireProductEntity = {
  token: "p_822hrhadz5",
  type: "product",
  name: "Tie Dye Baseball Cap",
  brandToken: "b_9e6f6x9c2j",
  brandName: "Kidpik",
  imageUrl:
    "https://cdn.faire.com/fastly/0300e376591bd411df925c9347d228a360b59d305e724d63225eb91c1172e010.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c0fe5c41f9a2841cb0f269a71bd48a573cfa30adb5c784e61ece2e31429a5024.jpeg",
    "https://cdn.faire.com/fastly/416f0a959d248b604ee7415a3898c01aa91706bf4d39af0d0ec11c52a8374967.jpeg",
    "https://cdn.faire.com/fastly/358d60c53ba57189b78de0af6a0f6428aa0c122e3e511d2b98e65b3f97c8fad2.jpeg",
  ],
  priceDollars: 2.49,
  description:
    "This Kidpik Girl's Tie dye Baseball cap will give you all the fun without the sun! The pattern is adorable and is featured in two color ways: Pink and Blue & Teal and Grey. The adjustable strap will give this hat a lot of wear over the years. Pair with her active apparel or casual look to bring some fun into the day.\n\n\n * Tie dye pattern \n * Breathable eyelets \n * Adjustable buckle strap back \n * Inside Sweatband \n * Hand Wash \n * Imported ",
  tags: [],
  msrpDollars: 9.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:41.259Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
